/**
 * @generated SignedSource<<28ee3acfc2f68e574ee5d2b426ef8a4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetFlexiUnitVideoLabelVideo$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersGetFlexiUnitVideoLabelVideo";
};
export type helpersGetFlexiUnitVideoLabelVideo$key = {
  readonly " $data"?: helpersGetFlexiUnitVideoLabelVideo$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetFlexiUnitVideoLabelVideo">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetFlexiUnitVideoLabelVideo"
};

(node as any).hash = "21795ae85658ae4e8c925850fb134a13";

export default node;
